import { createSlice } from '@reduxjs/toolkit';
import { NOTIFICATIONAPI } from '../../API';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const countrystatecityslice = createSlice({
    name: 'rate', // 👈 Retained original slice name to match existing action types
    initialState: {
        country: {
            loading: false,
            data: []
        },
        state: {
            loading: false,
            data: []
        },
        multistates: {
            loading: false,
            data: []
        },
        city: {
            loading: false,
            data: []
        }
    },
    reducers: {
        getCountry: (state) => {
            return {
                ...state,
                country: {
                    loading: true,
                    data: []
                }
            };
        },
        getCountrySuccess: (state, action) => {
            return {
                ...state,
                country: {
                    loading: false,
                    data: action && action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : []
                }
            };
        },
        getCountryFailure: (state) => {
            return {
                ...state,
                country: {
                    loading: false,
                    data: []
                }
            };
        },
        getState: (state) => {
            return {
                ...state,
                state: {
                    loading: true,
                    data: []
                }
            };
        },
        getStateSuccess: (state, action) => {
            const payloadData = action?.payload?.response?.data?.data || action?.payload?.data?.data || [];
            const country = action?.payload?.country || "";
            return {
                ...state,
                state: {
                    loading: false,
                    data: payloadData,
                    lastFetchedCountry: country
                }
            };
        },
        getStateFailure: (state) => {
            return {
                ...state,
                state: {
                    loading: false,
                    data: []
                }
            };
        },
        getMultiStates: (state) => {
            return {
                ...state,
                multistates: {
                    loading: true,
                    data: []
                }
            };
        },
        getMultiStatesSuccess: (state, action) => {
            return {
                ...state,
                multistates: {
                    loading: false,
                    data: action && action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : []
                }
            };
        },
        getMultiStatesFailure: (state) => {
            return {
                ...state,
                multistates: {
                    loading: false,
                    data: []
                }
            };
        },
        getCity: (state) => {
            return {
                ...state,
                city: {
                    loading: true,
                    data: []
                }
            };
        },
        getCitySuccess: (state, action) => {
            return {
                ...state,
                city: {
                    loading: false,
                    data: action && action.payload && action.payload.data && action.payload.data.data ? action.payload.data.data : []
                }
            };
        },
        getCityFailure: (state) => {
            return {
                ...state,
                city: {
                    loading: false,
                    data: []
                }
            };
        }
    }
});

export const { 
    getCountry, getCountrySuccess, getCountryFailure, 
    getState, getStateSuccess, getStateFailure,
    getMultiStates, getMultiStatesSuccess, getMultiStatesFailure, 
    getCity, getCitySuccess, getCityFailure 
} = countrystatecityslice.actions;

// ─── SAFE THUNKS WITH DEDUPLICATION GUARDS ───

export const fetchCountry = (options = {}) => (dispatch, getStateState) => {
    const force = typeof options === 'object' && options?.force;
    const current = getStateState()?.countrystate?.country;

    if (!force && (current?.loading || (current?.data && current.data.length > 0))) {
        return;
    }

    dispatch(getCountry());
    try {
        NOTIFICATIONAPI.get('/utility/country')
            .then(function (response) {
                dispatch(getCountrySuccess(response));
            })
            .catch(function () {
                dispatch(getCountryFailure());
            });
    } catch (error) {
        dispatch(getCountryFailure());
    }
};

export const fetchState = (country, options = {}) => (dispatch, getStateState) => {
    // 1. Guard against invalid/empty country codes
    if (!country || typeof country !== 'string' || country.trim() === "") {
        return;
    }

    // 2. Safely extract options without throwing errors
    const force = typeof options === 'object' && options !== null ? options.force : false;
    const current = getStateState()?.countrystate?.state;

    // 3. Check if we already fetched states for THIS SPECIFIC country
    const isSameCountry = current?.lastFetchedCountry === country;

    if (!force && isSameCountry && (current?.loading || (current?.data && current.data.length > 0))) {
        return;
    }

    dispatch(getState());
    try {
        NOTIFICATIONAPI.get('/utility/state/' + country)
            .then(function (response) {
                // Attach the country to the payload so we can track the last fetched country
                dispatch(getStateSuccess({ response, country }));
            })
            .catch(function (error) {
                dispatch(getStateFailure(error?.response));
            });
    } catch (error) {
        dispatch(getStateFailure());
    }
};

export const fetchMultiStates = (country, options = {}) => (dispatch, getStateState) => {
    if (!country) return;

    const force = typeof options === 'object' && options?.force;
    const current = getStateState()?.countrystate?.multistates;

    if (!force && (current?.loading || (current?.data && current.data.length > 0))) {
        return;
    }

    dispatch(getMultiStates());
    try {
        NOTIFICATIONAPI.get('/utility/states/' + country)
            .then(function (response) {
                dispatch(getMultiStatesSuccess(response));
            })
            .catch(function () {
                dispatch(getMultiStatesFailure());
            });
    } catch (error) {
        dispatch(getMultiStatesFailure());
    }
};

export const fetchCity = (country, state, options = {}) => (dispatch, getStateState) => {
    if (!country || !state) return;

    const force = typeof options === 'object' && options?.force;
    const current = getStateState()?.countrystate?.city;

    if (!force && (current?.loading || (current?.data && current.data.length > 0))) {
        return;
    }

    dispatch(getCity());
    try {
        NOTIFICATIONAPI.get('/utility/city/' + country + '/' + state)
            .then(function (response) {
                dispatch(getCitySuccess(response));
            })
            .catch(function () {
                dispatch(getCityFailure());
            });
    } catch (error) {
        dispatch(getCityFailure());
    }
};

export default countrystatecityslice.reducer;